import { Component } from '@grafikr/components';
import fastdom from 'fastdom';

import { assertNonNullish, NonNullish } from 'utils/nullish-check';
import repaint from 'utils/repaint';

export default Component((node) => {
  const { target, stop } = node.dataset;

  assertNonNullish(target, '[data-target] is required');

  const update = ({ isIntersecting }: IntersectionObserverEntry) => {
    const isActive = !isIntersecting;

    if (isActive) {
      fastdom.measure(() => {
        node.hidden = false;
        repaint(node);
      });

      fastdom.mutate(() => {
        node.classList.add('is-active');
      });
    } else {
      fastdom.mutate(() => {
        node.classList.remove('is-active');
      });
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        update(entry);
      });
    },
    {
      rootMargin: node.dataset.offset ?? '0px',
    },
  );

  const init = () => {
    const targetElement = document.querySelector<HTMLElement>(target);

    if (stop) {
      const stopElement = NonNullish(
        document.querySelector<HTMLElement>(stop),
        `${stop} attribute, didn't match any elements on site.`,
      );

      observer.observe(stopElement);
    }

    if (target && targetElement) {
      observer.observe(targetElement);
    }
  };

  init();
});
